// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-carousel_layout__0M7zq","sliderButton":"speaker-carousel_sliderButton__T_Wtm","prev":"speaker-carousel_prev__jOQVw","next":"speaker-carousel_next___KgJ4"};